module.exports = __webpack_public_path__ + "img/accessability_en.f477c07.jpg";